import classNames from 'classnames'
import Style from './index.module.less'
import { useTranslation } from 'react-i18next'
const BDSCard = ({ cardData }: { cardData: any }) => {
  const { t } = useTranslation()
  return (
    <div className={Style.BDSCard}>
      <div className={Style.BDSCardItem}>
        <div className={Style.BDSCardItemLabel}>{t('explorer_111')}</div>
        <div
          className={classNames({
            [Style.BDSCardItemValue]: true,
            font_14: true,
          })}
        >
          {cardData?.height}
        </div>
      </div>
      <div className={Style.BDSCardItem}>
        <div className={Style.BDSCardItemLabel}>stateRoot</div>
        <div
          className={classNames({
            [Style.BDSCardItemValue]: true,
            font_14: true,
          })}
        >
          {cardData?.stateRoot}
        </div>
      </div>
    </div>
  )
}

export default BDSCard
